import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import TimeAgo from 'components/utils/LocalizedTimeAgo';
import { BsThreeDots, BsArrowLeftShort } from 'react-icons/bs'
import { removeMemberOf } from '../../../features/memberships/membershipSlice'
import { imgUrl } from 'features/constants';
import { setViewConfirmModal, setConfirmModalData } from 'features/modal/modalSlice';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next'

function MemberOfItem( { userId, fullName, username, image, isAdmin } ) {
//should be paginated since churches will potentially have a lot of members
//alos, allow to search your members
    const navigate = useNavigate()
    const { t } = useTranslation('settings')
    const ref = useRef()
    const ref2 = useRef()
    const dispatch = useDispatch()
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const [confirm, setConfirm] = useState(false);
    const ref3 = useRef()

    const handleRemove = () => { 
        dispatch(removeMemberOf({ churchId: userId } ))
    }
     
    const handleCancelRemove = () => {
        setConfirm(false);
        setIsDropdownOpen(false)
    }

    const handleLeaveChurch = () => {
        dispatch(setConfirmModalData({
            text: t('membership.leaveConfirm', { church: fullName }),
            handler: handleRemove,
            confirmBtnBackgroundHover: 'red',
        }))
    
        dispatch(setViewConfirmModal(true))
    }

    return (
        <div className='myMembersItemWrap'>
                <div className='mMIInfo'>
                    <img className='reqItemImage' src={image} alt='none' />

                    <div className='mMIName'>
                            <ChurchNameRow>
                                <Link to={`/${username}`}> <div className='mMIFullName'>{fullName}</div></Link>
                                {isAdmin && <AdminBadge>{t('membership.admin')}</AdminBadge>}
                            </ChurchNameRow>
                    </div>
                </div>


                <div  className='mMIDots'>
                    <div ref={ref} onClick={() => setIsDropdownOpen(prevState => !prevState)}>< BsThreeDots />   </div>
                    { isDropdownOpen && (
                            <div className='memberDotsWrap'> 
                                
                                <li ref={ref3} onClick={handleLeaveChurch} className='leaveChurch'>{t('membership.leave')}</li>
                            </div>
                        )
                    }
                </div> 
        </div>
    )
}

export default MemberOfItem

const ChurchNameRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`

const AdminBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    padding: 0 8px;
    border-radius: 999px;
    background: rgba(0, 180, 204, 0.1);
    border: 1px solid rgba(0, 180, 204, 0.24);
    color: var(--themeColor);
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
`
